import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CheckDto } from "src/app/shared/models/check-dto";
import { ProductUseIntervalMetric } from "src/app/shared/models/DTO/productUseMetric.dto";
import { ChartLegendPosition } from "src/app/shared/models/enums/ChartLegendPosition.enum";
import { GuestSurvey } from "src/app/shared/models/focusDataModels/GuestSurvey";

@Component({
	selector: "app-online-dash",
	templateUrl: "./online-dash.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class OnlineDashComponent implements OnInit {
	guestSurvey = {
		happy: 0,
		lastHappy: undefined,
		unhappy: 0,
		lastUnhappy: undefined,
		comments: 0,
	};

	metrics = {
		currentDay: {
			onlineOrders: 0,
			onlineRevenue: 0,
		},
		previousDay: {
			onlineOrders: 0,
			onlineRevenue: 0,
		},
		onlineOrderPercent: 0,
		lastCheckDate: undefined,
		loadComplete: false,
	};

	onlineOrders: CheckDto[];

	productUseChart = {
		options: undefined,
		data: undefined,
		type: "bar",
	};

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.venueService.productStatisticMetric.subscribe((data) => {
			if (data?.data?.length > 0) this.buildProductUseChart(data.data);
		});
		this.venueService.checks.subscribe((data) => {
			if (
				data?.length > 0 &&
				data.some((i) => i.businessDate === this.app.moment().format("YYYY-MM-DD")) &&
				data.some((i) => i.businessDate === this.app.moment().add(-1, "day").format("YYYY-MM-DD"))
			) {
				this.buildMetrics();
			}
		});
		this.guestSurveyGet(this.venueService.venueKey);
	}

	async buildMetrics() {
		const currentDayChecks = this.venueService.checks.value.filter((i) => i.businessDate === this.app.moment().format("YYYY-MM-DD"));
		const previousDayChecks = this.venueService.checks.value.filter((i) => i.businessDate === this.app.moment().add(-1, "day").format("YYYY-MM-DD"));
		if (currentDayChecks) {
			this.metrics.currentDay.onlineOrders = currentDayChecks.length;
			this.metrics.currentDay.onlineRevenue = currentDayChecks.reduce((a, b) => a + b.total, 0);
			console.log(this.metrics.currentDay.onlineRevenue);
			this.onlineOrders = currentDayChecks;
		}
		if (previousDayChecks) {
			this.metrics.previousDay.onlineOrders = previousDayChecks?.length;
			this.metrics.previousDay.onlineRevenue = previousDayChecks?.reduce((a, b) => a + b.total, 0);
		}
		if (this.metrics.currentDay.onlineOrders > 0 && this.metrics.previousDay.onlineOrders > 0) {
			this.metrics.onlineOrderPercent = this.metrics.currentDay.onlineRevenue / this.metrics.previousDay.onlineRevenue;
		}
		this.metrics.loadComplete = true;
		console.log(this.metrics);
	}

	async guestSurveyGet(venueKey) {
		this.guestSurvey.happy = 0;
		this.guestSurvey.unhappy = 0;
		this.guestSurvey.lastHappy = undefined;
		this.guestSurvey.lastUnhappy = undefined;
		const resp = await this.focuslink.fdGuestSurveyGetAll(venueKey, false);
		const surveys: GuestSurvey[] = resp.map((i) => {
			return new GuestSurvey(i);
		});

		for (let survey of surveys) {
			if (survey.happy) {
				this.guestSurvey.happy += 1;
				if (this.guestSurvey.lastHappy > survey.created) {
					this.guestSurvey.lastHappy = survey.created;
				}
			} else {
				this.guestSurvey.unhappy += 1;
				if (this.guestSurvey.lastUnhappy > survey.created) {
					this.guestSurvey.lastUnhappy = survey.created;
				}
			}
			if (survey.comment) {
				this.guestSurvey.comments += 1;
			}
		}
		return;
	}

	async buildProductUseChart(metricData: ProductUseIntervalMetric[]) {
		const metricDates: {
			date: string;
			visits: number;
			completes: number;
			abandons: number;
		}[] = [];

		metricData.forEach((i) => {
			let date = metricDates.find((md) => md.date === i.date);
			if (!date) {
				metricDates.push({
					date: i.date,
					visits: i.visits,
					completes: i.completes,
					abandons: i.abandons,
				});
			} else {
				date.visits += i.visits;
				date.completes += i.completes;
				date.abandons += i.abandons;
			}
		});

		const data = {
			labels: metricDates.map((i) => this.app.moment(i.date, "YYYY-MM-DD").format("l")),
			datasets: [
				{
					label: "Visits",
					data: metricDates.map((i) => i.visits),
					fill: false,
					borderColor: "#006394",
				},
				{
					label: "Completed orders",
					data: metricDates.map((i) => i.completes),
					fill: false,
					borderColor: "#58b81d",
				},
				{
					label: "Abandoned cart",
					data: metricDates.map((i) => i.abandons),
					fill: false,
					borderColor: "#ed4242",
				},
			],
		};

		this.productUseChart.data = data;
		this.productUseChart.options = this.app.references.chartConfig(ChartLegendPosition.NONE, false, false);
		this.productUseChart.options.scales = {
			x: {
				stacked: true,
			},
			y: {
				stacked: true,
			},
		};
	}
}
